<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}人员证书`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="姓名" prop="empName">
            <el-input v-model.trim="editForm.empName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书名称" prop="certName">
            <el-input v-model.trim="editForm.certName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="证书到期日期" prop="endTime">
            <el-date-picker
              v-model="editForm.endTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="关联文件">
            <UploadButton
              v-model="fileList"
              :limit="9"
              :fileType="['jpg', 'jpeg', 'png', 'zip', 'rar', 'doc', 'docx', 'pdf', 'PDF']"
              :paramsData="{ type: 'upt_certificate' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import UploadButton from '@/components/UploadArea/UploadButton';

import { editUserCert, getUserCert } from '@/api/archives';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {
        id: '',
        empNo: '',
        empName: '',
        deptName: '',
        certName: '',
        certType: 0,
        remark: '',
        endTime: ''
      },
      fileList: [],
      rules: {
        empName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        certName: [{ required: true, message: '请输入证书名称', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  filters: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.detailLoading = true;
      try {
        const { data } = await getUserCert({ id: this.activeId });

        if (data) {
          this.editForm = {
            id: data.id,
            empNo: data.empNo,
            empName: data.empName,
            deptName: data.deptName,
            certName: data.certName,
            certType: data.certType,
            issueTime: data.issueTime,
            endTime: data.endTime,
            remark: data.remark
          };
        }
        if (data.fileId) {
          this.fileList = data.fileList.map(item => {
            return {
              fileId: item.fileId,
              fileName: item.fileName,
              filePath: item.filePath
            };
          });
        }
      } finally {
        this.detailLoading = false;
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const fileIds = this.fileList.map(item => item.fileId).join(',');
          const params = {
            ...this.editForm,
            fileId: fileIds
          };

          try {
            await editUserCert(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
